// Who's behind the site, for the privacy policy, terms of use, refund policy, accessibility statement and AI policy: each value fills the
// {placeholder} of the same name in their Markdown (src/i18n/en/legal), and the effective dates are shown above them.
// Bracketed values are placeholders to fill in before going live.
export const legal = {
    companyName: 'Tristar Advanced Software, LLC',
    companyAddress: '6545 Market Ave. North, STE 100, Canton, OH 44721, USA',
    // An address for legal inquiries, shown on the legal pages: null until one is designated, which hides the sentences
    // that give it. Never the support address: customers reach support through tickets (/support/new).
    legalEmail: 'legal@tristaradvanced.com',
    // The state whose laws govern the terms of use, e.g. 'California'.
    governingState: 'Ohio',
    // GDPR Article 27 representatives: null until appointed, which hides them.
    euRepresentative: null as string | null,
    ukRepresentative: null as string | null,
    // Change with any change to the policy or terms (which also says to tell account holders).
    privacyEffective: 'October 19, 2026',
    termsEffective: 'October 23, 2026',
    refundsEffective: 'October 16, 2026',
    // When the site was last checked against the accessibility statement's standard.
    accessibilityReviewed: 'October 10, 2026',
    // Change with any change to the AI policy.
    aiPolicyEffective: 'November 3, 2026'
};
